import {useMutation} from '@tanstack/react-query';
import {useKeyplayApi} from '../../context/ApiContext';
import {Role} from '../../shared/user';
import {useUser} from '../../context/UserContext';
import {getCustomClaims} from '../../shared/auth';

export function useUpdateUser() {
  const makeApiCall = useKeyplayApi();
  return useMutation({
    mutationFn: ({role}: {role: Role}) =>
      makeApiCall('/customer/user', {
        data: {role},
        method: 'POST',
      }),
  });
}

export function useIsKeyplayAdmin() {
  const user = useUser();
  return getCustomClaims(user.auth0).isKeyplayAdmin;
}

export function useIsTemporaryMembership() {
  const user = useUser();
  return getCustomClaims(user.auth0).isTemporarayMembership;
}
